(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/single-rows-container.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/single-rows-container.js');

'use strict';

svs.lotto.components.play.views.SingleRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-md-bottom-0 padding-md-h-2',
  regions: {
    andraChansenBannerRegion: '#andraChansenBannerRegion',
    boardContainerRegion: '#boardContainerRegion',
    rowsRegion: '#rowsRegion'
  },
  template(data) {
    return svs.lotto.components.play.templates.single_rows_container(data);
  },
  onRender() {
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model
    }));
    this.showChildView('rowsRegion', new svs.numbergames.game.views.SingleRowsContainer({
      model: this.model,
      behaviors: [{
        behaviorClass: svs.numbergames.accessibility.behaviors.KeyboardNavigation
      }, {
        behaviorClass: Marionette.Behavior.extend({
          onRender() {
            const rowsView = this.view.getChildView('singleRowsRegion');
            const isACView = view => view instanceof svs.lotto.components.play.views.AndraChansenRowBanner;
            rowsView.viewComparator = (a, b) => isACView(a) - isACView(b);
            rowsView.addChildView(new svs.lotto.components.play.views.AndraChansenRowBanner({
              model: this.view.model,
              className: 'numbergames-single-row-banner'
            }), this.view.model.get('boards').length);
          }
        })
      }]
    }));
  }
});

 })(window);